import { Music, Utensils, Sparkles, BedDouble } from "lucide-react";
import { Reveal, Eyebrow } from "../components/Reveal";

const U = "?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=80&w=1200";
const CROWD = "https://images.unsplash.com/photo-1619229667009-e7e51684e8e6" + U;
const DINNER = "https://images.unsplash.com/photo-1561065270-5c2af775b542" + U;

const STEPS = [
  [Utensils, "6 PM · Dinner", "Start with patio dining or a chef's tasting menu steps from the stage."],
  [Music, "8 PM · Showtime", "Open-air sound, big lights and a crowd that sings every word."],
  [Sparkles, "After · Nightlife", "Keep the night going at nearby lounges, entertainment venues and the illuminated Falls."],
  [BedDouble, "Late · Stay Over", "Walk back to your room. Brunch tomorrow, no drive home tonight."],
];

export const Experience = () => (
  <section id="experience" data-testid="experience-section" className="mx-auto max-w-7xl px-5 py-20 lg:px-12 lg:py-32">
    <div className="grid gap-6 md:grid-cols-12">
      <Reveal className="flex flex-col justify-between gap-8 rounded-[28px] border border-white/10 bg-[#12141C] p-8 sm:p-10 md:col-span-7">
        <div>
          <Eyebrow>The Experience</Eyebrow>
          <h2 className="mt-4 font-display text-5xl font-extrabold uppercase leading-[0.9] text-white sm:text-6xl">More than a show. <span className="text-gradient">A whole night out.</span></h2>
        </div>
        <p className="max-w-xl text-zinc-300 md:text-lg">Warm summer evenings, an open-air stage and thousands of fans under the lights. Come for the music, stay for dinner, the district's energy and a night in Fallsview.</p>
      </Reveal>
      <Reveal delay={0.1} className="relative min-h-[320px] overflow-hidden rounded-[28px] md:col-span-5">
        <img src={CROWD} alt="Crowd with raised hands at an outdoor summer concert" loading="lazy" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0C10]/80 to-transparent" />
        <p className="absolute bottom-6 left-6 font-mono text-xs uppercase tracking-[0.25em] text-white">Open-air · All summer</p>
      </Reveal>
      <Reveal delay={0.05} className="relative min-h-[320px] overflow-hidden rounded-[28px] md:col-span-5">
        <img src={DINNER} alt="Friends sharing dinner at a warmly lit restaurant" loading="lazy" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-tr from-[#9D4EDD]/40 to-transparent mix-blend-multiply" />
      </Reveal>
      <Reveal delay={0.15} className="rounded-[28px] border border-white/10 bg-[#12141C] p-8 sm:p-10 md:col-span-7">
        <ol className="grid gap-6 sm:grid-cols-2">
          {STEPS.map(([Icon, title, text]) => (
            <li key={title} className="group">
              <span className="mb-3 grid h-11 w-11 place-items-center rounded-full border border-[#FF5A1E]/40 text-sunset transition-colors group-hover:bg-sunset group-hover:text-black"><Icon size={18} /></span>
              <p className="font-display text-xl font-bold uppercase text-white">{title}</p>
              <p className="mt-1 text-sm text-zinc-300">{text}</p>
            </li>
          ))}
        </ol>
      </Reveal>
    </div>
  </section>
);
